<template>
  <div
    id="idModalRetryJob"
    class="modal-job-monitoring">
    <div class="wrap-modal-job-monitoring">
      <img
        src="@/assets/icon/retry-job.svg"
        alt="retry-job-icon"
      >
      <p class="title">Are you sure to <span class="retry">Retry Process</span> ?</p>
      <p
        v-if="isRetryAll"
        class="info">All Current {{ formatedStatus }} Job</p>
      <p
        v-else
        class="info">{{ formatedStatus }} Job In This Running ID ({{ runHistoryId }})</p>
      <div class="button-modal-job-monitoring">
        <b-button
          class="btn-retry"
          @click="handleRetryJob"
        >
          Yes
        </b-button>
        <b-button
          @click="closeModalRetryJob"
        >
          Cancel
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import jApi from '@/services/jApi';
import { mapActions } from 'vuex';

export default {
  props: {
    visprogId: { type: String, default: '', required: true },
    runHistoryId: { type: String, default: '' },
    isRetryAll: { type: Boolean, default: false, required: true },
    status: { type: String, default: 'Cancel', required: true },
    isDedicated: { type: Boolean, default: false },
  },

  computed: {
    formatedStatus() {
      return this.status === 'error' ? 'Error' : 'Canceled';
    },
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'toggleSuccess', 'showLoading', 'hideLoading']),

    closeModalRetryJob() {
      this.$emit('close');
    },

    handleRetryJob() {
      if (this.isRetryAll && this.isDedicated) {
        this.retryAllDedicatedJob();
      } else if (this.isRetryAll) {
        this.retryAllJob();
      } else if (!this.isRetryAll && this.isDedicated) {
        this.retryDedicatedJob();
      } else {
        this.retryJob();
      }

      this.closeModalRetryJob();
    },

    async retryAllJob() {
      this.showLoading();
      try {
        const api = jApi.generateApi();
        const res = await api.post(`nocode-job-monitor/jobs/${this.visprogId}/retry`);
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },

    async retryJob() {
      this.showLoading();
      try {
        const api = jApi.generateApi();
        const res = await api.post(`nocode-job-monitor/jobs/${this.visprogId}/retry/${this.runHistoryId}`);
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },

    async retryAllDedicatedJob() {
      this.hideLoading();
      try {
        const api = jApi.generateApi();
        const url = this.status === 'cancel' ? 'nocode-dedicated-job/retry/canceled' : 'nocode-dedicated-job/retry/error';
        const res = await api.get(url, { params: { job_id: this.visprogId } });
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },

    async retryDedicatedJob() {
      this.showLoading();
      try {
        const api = jApi.generateApi();
        const params = {
          job_id: this.visprogId,
          running_id: this.runHistoryId,
          status: this.status.toLowerCase(),
        };
        const res = await api.get('nocode-dedicated-job/retry/running-id', { params });
        if (res.data.error) {
          this.hideLoading();
          this.toggleProblem(res.data.message);
        } else {
          this.hideLoading();
          this.toggleSuccess(res.data.message);
          this.$emit('completed');
        }
      } catch (err) {
        this.hideLoading();
        this.toggleProblem(err.response.data.message || err.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalRetryJob.vue